<template>
  <article-detail-component  v-if="article">

    <div slot="title" v-if="!$store.state.isEnhanced">
      <div class="title">{{ article.title }}</div>

      <issue-authors v-bind:authors="article.authors"></issue-authors>
    </div>

    <sidebar-article-section slot="bar" :article="article"></sidebar-article-section>

    <div slot="authors">
      <issue-authors class="" v-bind:authors="article.authors"></issue-authors>
    </div>

    <div slot="current_article" class="current-issue">
      <em>Current Article:</em>
      <condensed-issue class="mt-2" v-bind:issue="article"></condensed-issue>
    </div>

    <div class="row correspondence-to">
      <em>Correspondence to: </em>
      <span v-for="contact in correspondenceTo" :key="contact.email">
        {{contact.firstName}}&nbsp;{{contact.lastName}}:&nbsp;<a :href="`mailto:${contact.email}`">{{contact.email}}</a></span>
    </div>
    <div v-show="!detailsMode" class="row">
      <author v-for="author in authors" :key="author.id" v-bind:author="author" class="col-xs-12" :class="{'col-md-6': !$store.state.isEnhanced}">
        <span class="link" slot="details-link" @click="openDetails(author.id)">Read More ></span>
      </author>
    </div>
    <author-details v-if="detailsMode" :author-id="authorDetailId">
      <div slot="header" class="row no-gutters justify-content-between">
        <span class="link" @click="closeDetails">< Back to all authors</span>
        <b-button class="link" variant="link" @click="closeDetails"><icon name="times"></icon></b-button>
      </div>
    </author-details>
  </article-detail-component>
</template>

<script>
  import ArticleDetailComponent from '@/components/publications/article-detail/ArticleDetailComponent'
  import Author from '@/components/shared/AuthorComponent'
  import AuthorDetails from '@/components/shared/AuthorDetailsComponent'
  import IssueAuthors from '@/components/shared/IssueAuthorsComponent'
  import CondensedIssue from '@/components/shared/CondensedIssueComponent'
  import UtilityMixin from '@/components/shared/mixins/UtilityMixin'
  import SidebarArticleSection from '@/components/main-layout/sidebar/SidebarArticleSectionComponent'

  export default {
    name: 'article-detail-authors',
    components: {
      ArticleDetailComponent,
      Author,
      AuthorDetails,
      IssueAuthors,
      CondensedIssue,
      SidebarArticleSection
    },
    mixins: [UtilityMixin],
    data () {
      return {
        detailsMode: false,
        authorDetailId: undefined,
        article: false,
        currentIssueCutted: false,
        authors: [],
        // ToDO: replace with data from services
        correspondenceTo: [
          { firstName: 'Name',
            lastName: 'LastName',
            email: 'text@test.com'
          },
          { firstName: 'Name1',
            lastName: 'LastName1',
            email: 'text@test.com'
          }
        ]
      }
    },
    methods: {
      openDetails (authorId) {
        this.detailsMode = true
        this.authorDetailId = authorId
      },
      closeDetails () {
        this.detailsMode = false
        this.authorDetailId = undefined
      }
    },
    created () {
      this.$parent.$parent.prevPage = false
      this.$parent.$parent.nextPage = {name: 'article-metrics'}
      this.$parent.$parent.prevSlide = {name: 'article-detail'}
      this.$parent.$parent.nextSlide = {name: 'article-detail-related'}

      if (this.$parent.article) {
        this.article = Object.assign({}, this.$parent.article)
      }
      // TODO: replace service call for authors list
      this.$http.get(this.$store.state.dataUrlMockFile).then(function (response) {
        this.authors = response.body.editorsInChief
      }, function () {
      })
    }
  }
</script>


<style scoped lang="scss">
  .title {
    color: $primary-color;
    font-size: 32px;
  }
  .correspondence-to {
    color: $primary-color;
    font-family: 'Merriweather', serif;
    border-top: 1px solid $grey-border;
    border-bottom: 1px solid $grey-border;
    padding: 10px 0px;
    margin: 10px 0;
    background-color: $light-grey-color;
    em {
      font-size: 600;
    }
    span {
      padding-left: 10px;
      a {
        text-decoration: underline;
      }
    }
  }
  .link {
    font-style: italic;
    cursor: pointer;
  }
  .current-issue {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid $grey-border;
  }
  .article-quick-links {
    margin-bottom: 40px;
  }

</style>



// WEBPACK FOOTER //
// AuthorsPage.vue?1a8fb50e